export default function acceptCookies() {
    // Check if the 'cookies' cookie exists
    const cookies = document.cookie.split(';').find(cookie => cookie.trim().startsWith('cookies='));
    
    // If the 'cookies' cookie doesn't exist, make the cookies notice visible
    if (!cookies) {
        const cookiesNotice = document.querySelector('[data-element="cookies-notice"]');
        if (cookiesNotice) {
            cookiesNotice.classList.remove('hidden'); // Make the cookies notice visible
        }
    }

    // Handle the acceptance of cookies when the button is clicked
    const closeBtn = document.querySelector('[data-action="cookies-accepted"]');
    
    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
            let now = new Date();
            now.setTime(now.getTime() + (1 * 24 * 60 * 60 * 1000)); // Set cookie expiration to 1 day
            document.cookie = "cookies=accepted;expires=" + now.toUTCString() + ";path=/"; // Set the cookie
            const cookiesNotice = document.querySelector('[data-element="cookies-notice"]');
            if (cookiesNotice) {
                cookiesNotice.remove(); // Remove the cookies notice
            }
        });
    }
}


